export default __webpack_public_path__ + "static/media/temple.c57f882d.svg";